import { Breakpoints, PrimaryColors } from '@/common/theme/constants';

import { SxProps } from '@mui/material';

export const searchBoxStyles: SxProps = {
  display: 'inline-block',
  width: '100%',
  border: `1px solid ${PrimaryColors.carbon}`,
  padding: '12px',
  position: 'relative',
  color: 'inherit',
  fontSize: '16px',

  [`@media (min-width:${Breakpoints.md}px)`]: {
    padding: '24px',
  },
};

export const inputStyles: SxProps = {
  width: '100%',
  border: 'none',
};

export const iconStyles: SxProps = {
  position: 'absolute',
  right: '12px',
  top: '18px',
  fontSize: '16px',

  [`@media (min-width:${Breakpoints.md}px)`]: {
    right: '24px',
    top: '15px',
    fontSize: '24px',
  },
};
